import { http } from "./httpServices";
import {
  TOP_UP_COUNTS,
  TOP_UP_TRANSACTION_DOWNLOAD_REPORT,
  TRANSACTION_CUSTOMER,
  TRANSACTION_DOWNLOAD_REPORT,
  TRANSACTION_MERCHANT,
  TRANSACTION_TOPUPS,
} from "./constants";

export function getCustomerTransaction(
  page: number,
  limit: number,
  searchText: string
) {
  return http.get(
    `${TRANSACTION_CUSTOMER}?page=${page}&limit=${limit}&searchText=${searchText}`
  );
}

export function getMerchantTransaction(
  page: number,
  limit: number,
  merchantID: string | undefined,
  searchText: string,
  date: Date | string,
  transactionSelected: string
) {
  return http.get(
    `${TRANSACTION_MERCHANT}/${merchantID}?page=${page}&limit=${limit}&searchText=${searchText}&date=${date}&transactionType=${transactionSelected}`
  );
}

export function getTopUpsTransaction(
  page: number,
  limit: number,
  searchText: string
) {
  return http.get(
    `${TRANSACTION_TOPUPS}?page=${page}&limit=${limit}&searchText=${searchText}`
  );
}

export function downloadReport(
  startDate: string,
  endDate: string,
  merchantID: string
) {
  return http.get(
    `${TRANSACTION_DOWNLOAD_REPORT}/${merchantID}?startDate=${startDate}&endDate=${endDate}`,
    { responseType: "blob" }
  );
}

export function downloadTopUpReport(reportDate: string) {
  return http.get(`${TOP_UP_TRANSACTION_DOWNLOAD_REPORT}?date=${reportDate}`, {
    responseType: "blob",
  });
}

export function getTopUpTransactionCounts() {
  return http.get(`${TOP_UP_COUNTS}`);
}
